import React from "react"
import { useLocation, Route, Routes, Navigate } from "react-router-dom"
// reactstrap components
import { Container } from "reactstrap"
// core components
import { AdminNavbar } from "../components/AdminNavbar"
import { AdminFooter } from "../components/AdminFooter"
import { Sidebar } from "../components/Sidebar"

// rider layout
import RiderLayout from "./RiderLayout"

// route
import routes from "./routes.js"
import { Auth } from "../../utils/auth"

const Admin = props => {
  const mainContent = React.useRef(null)
  const location = useLocation()
  const userRoles = Auth.roles()

  React.useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    if (mainContent.current) {
      mainContent.current.scrollTop = 0
    }
  }, [location])

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      // Use Auth.hasRole so role priority is respected (e.g. admin+rider won't get rider routes)
      // restrictToHub (opt-in per route) further narrows by hub name — can be
      // a single hub name or an array of allowed hub names (e.g. Transmittal:
      // ["Manila", "Mandaluyong"]). Exempts ONLY super_admin (the one truly
      // company-wide, no-hub tier). admin is deliberately NOT exempted here
      // even though it's company-wide elsewhere in this codebase — this
      // restriction is specific to hub-scoped features, so an admin assigned
      // to an out-of-scope hub must be gated exactly like a hub_admin would
      // be, matched by their own hub name. An admin genuinely based in an
      // allowed hub still gets through via that same match, same as any
      // hub_admin at that hub would.
      const hasPermission =
        prop.permissions &&
        prop.permissions.some(role => Auth.hasRole(role)) &&
        (!prop.restrictToHub ||
          Auth.hasRole("super_admin") ||
          (Array.isArray(prop.restrictToHub)
            ? prop.restrictToHub.includes(Auth.hubname())
            : Auth.hubname() === prop.restrictToHub))
      if (prop.layout === "/admin" && hasPermission) {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        )
      } else {
        return null
      }
    })
  }

  // Use RiderLayout only if user ONLY has rider role (no admin/hub_admin)
  const hasAdminAccess = userRoles.some(role =>
    ["super_admin", "admin", "hub_admin", "encoder"].includes(role),
  )
  if (!hasAdminAccess && userRoles.includes("rider")) {
    return <RiderLayout {...props} />
  }

  return (
    <>
      <Sidebar
        {...props}
        location={location}
        routes={routes}
        logo={{
          innerLink: "/admin",
          imgSrc: require("../../assets/img/brand/SPEED-Logo.png"),
          imgAlt: "Speedworks",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          brandText={
            Auth.hasRole("hub_admin") && !Auth.hasRole("admin")
              ? Auth.hubname()
              : "Speedworks"
          }
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  )
}

export default Admin
